// extracted by mini-css-extract-plugin
export default {"raMainScreen":"RaMain_raMainScreen__mPahw"};